// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lJxeB","field":"styles_field__Z2q8k","fieldCol":"styles_fieldCol__3_w2y","diffCol":"styles_diffCol__2Ulku","diff":"styles_diff__2M1T6"};